import { render, staticRenderFns } from "./InsightEditor.vue?vue&type=template&id=0bbfad62&"
import script from "./InsightEditor.vue?vue&type=script&lang=js&"
export * from "./InsightEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports